import { lazy, Suspense, useCallback, useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";

const VapiWidget = lazy(() => import("@/components/VapiWidget"));
const DISMISS_KEY = "cz-chat-teaser-dismissed";

/**
 * Floating chat trigger. After a few seconds it proactively shows the
 * assistant's intro message; clicking it opens the chat with that greeting.
 */
const ChatLauncher = () => {
  const [launched, setLaunched] = useState(false);
  const [teaser, setTeaser] = useState(false);

  const prefetch = useCallback(() => {
    void import("@/components/VapiWidget");
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem(DISMISS_KEY)) return;
    const t = setTimeout(() => setTeaser(true), 6000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setTeaser(false);
  };

  if (launched) {
    return (
      <Suspense fallback={null}>
        <VapiWidget defaultOpen />
      </Suspense>
    );
  }

  return (
    <>
      {teaser && (
        <div className="fixed bottom-44 right-6 z-50 w-[min(300px,calc(100vw-3rem))] animate-in fade-in slide-in-from-bottom-2 rounded-2xl rounded-br-sm border border-border bg-background p-4 shadow-xl">
          <button onClick={dismiss} aria-label="Dismiss" className="absolute right-2 top-2 rounded p-1 text-muted-foreground hover:text-foreground">
            <X className="h-3.5 w-3.5" />
          </button>
          <button onClick={() => setLaunched(true)} onPointerEnter={prefetch} className="text-left">
            <p className="text-xs font-semibold text-primary">Computer Zone</p>
            <p className="mt-1 pr-4 text-sm text-foreground">Hi there! 👋 Having computer trouble? I can help with repairs, pricing, or booking.</p>
          </button>
        </div>
      )}
      <button
        onClick={() => setLaunched(true)}
        onPointerEnter={prefetch}
        onTouchStart={prefetch}
        aria-label="Open chat"
        className="fixed bottom-24 right-6 z-50 flex items-center gap-2 rounded-full bg-primary px-5 py-4 font-semibold text-primary-foreground shadow-lg transition-all hover:opacity-90"
      >
        <MessageCircle className="h-5 w-5" />
        <span className="hidden sm:inline">Chat</span>
        {teaser && <span className="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full border-2 border-background bg-foreground" />}
      </button>
    </>
  );
};

export default ChatLauncher;
